
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.016.016H1.984c-.53 0-1 .203-1.406.609a1.852 1.852 0 00-.562 1.36v18L4 16h14.016c.53 0 .984-.188 1.359-.563.406-.406.61-.89.61-1.453v-12c0-.53-.204-.984-.61-1.359-.375-.406-.828-.61-1.36-.61zm-6.47 9.562L10 13 8.453 9.578 4.984 7.984l3.47-1.546L10 3.015l1.547 3.421 3.469 1.547-3.47 1.594z"}})])
          )
        }
      }
    